import { createSvgComponent } from "../../icon/createSvgComponent";
import LocationHeartFill from "@core/icon/assets/location-heart-fill.svg";
export default createSvgComponent(LocationHeartFill);